<template>
  <with-actions>
    <div class="card">
      <div class="card-body">
        <div class="form-group">
          <label>Name</label>
          <input class="form-control" v-model="application.name" />
        </div>
        <div class="form-group">
          <label>Redirect URI</label>
          <input class="form-control" v-model="application.redirect_uri" />
        </div>
        <div class="form-group">
          <label>Scopes</label>
          <input class="form-control" v-model="application.scopes" />
        </div>
      </div>
    </div>
    <hr />
    <div class="text-right">
      <button class="btn btn-primary" @click="save">Create</button>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';

export default {
  data: function () {
    return {
      application: {
        name: '',
        redirect_uri: '',
        scopes: 'read_orders read_shipments'
      }
    };
  },
  methods: {
    async save() {
      try {
        await Api.create('oauth_applications', this.application);
      } catch ({ errors }) {
        console.log(errors);
        _.each(errors, (e) => {
          Alerts.danger(e);
        });
      }
    }
  },
  async mounted() {},
  props: []
};
</script>

<style scoped></style>
